module.exports = __webpack_public_path__ + "static/media/under_maintenance.37254b69.png";